/**
 * We are a B2B game studio. We don't custody player funds, we don't run
 * a player-facing site, and we don't hold a gaming licence — nor do we
 * need one for the role we play.
 *
 * Licensing, age verification, KYC, and regulatory reporting sit with
 * the licensed operator that embeds the game. If your jurisdiction
 * requires a specific certification on the game itself (iTech Labs, GLI
 * math report, local regulator sign-off), we'll work through it case by
 * case with you once a pilot is on the table — we'll share the engine
 * source, the RTP math, and the test suite so auditors can reproduce
 * every round.
 */
export const LICENSING_STANCE = {
  heading: "Licensing sits with the operator",
  paragraphs: [
    "We are a B2B game studio. We don't custody player funds, we don't run a player-facing site, and we don't hold a gaming licence — nor do we need one for the role we play.",
    "Player-facing licensing, age verification, KYC, deposit caps, and regulatory reporting all sit with the licensed operator embedding the game. Your licence is the one that matters.",
    "If your jurisdiction requires a specific certification on the game itself (iTech Labs, GLI math report, local regulator sign-off), we'll work through it case by case with you when a pilot is on the table. Engine source, RTP math, and test suite are shared — auditors can reproduce every round bit-for-bit.",
  ],
};
